import { ActionType } from "../actions/actionTypes";

type VerifiedAddressState = {
  // an "address" is actually an array of 2 addresses.
  // The first contains the values that were submitted
  // and the 2nd contains the "LookupAddress" from the API.
  // In certain situations, these are both needed.
  addresses: Address[][];
};

const INITIAL_STATE: VerifiedAddressState = {
  addresses: []
};

export default (
  state: VerifiedAddressState = INITIAL_STATE,
  action: ActionType
): VerifiedAddressState => {
  switch (action.type) {
    case "ADD_VERIFIED_ADDRESS": {
      return { ...state, addresses: [...state.addresses, action.payload] };
    }
    case "CANCEL_APPLICATION": {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
